import { render, staticRenderFns } from "./KalustoSijainnitDialog.vue?vue&type=template&id=088b312a&scoped=true"
import script from "./KalustoSijainnitDialog.vue?vue&type=script&lang=js"
export * from "./KalustoSijainnitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b312a",
  null
  
)

export default component.exports